import { createTheme } from "@mantine/core";

export const theme = createTheme({
  defaultRadius: "xl",
  shadows: {
    ydao: "0 4px 20px rgba(153, 69, 255, 0.15)",
    ydaoHover: "0 8px 32px rgba(153, 69, 255, 0.25)",
  },
});
